import React, { Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import NoMatch from "./404";
import Unauthorized from "./403";
import PrivateRoute from "./privateRoute";
import Loading from "./_loading";
import JobStatus from "../jobStatus";
import LayoutDecider from "./layoutDecider";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";


const PostedJobEdit = React.lazy(() => import("../PostedJobEdit"));
const PostedJobDetail = React.lazy(() => import("../PostedJobDetail"));
const PostedJobs = React.lazy(() => import("../postedJobs"));
const Login = React.lazy(() => import("../login"));
const Register = React.lazy(() => import("../register"));
const ForgotPassword = React.lazy(() => import("../forgotPassword"));
const Profile = React.lazy(() => import("../profile"));
const ChangePassword = React.lazy(() => import("../changePassword"));
const PasswordReset = React.lazy(() => import("../passwordReset"));
const Dashboard = React.lazy(() => import("../admin/dashboard"));
const Jobs = React.lazy(() => import("../admin/jobs"));
const LeadGeneration = React.lazy(() => import("../admin/lead-generation"));
const LeadDetails = React.lazy(() => import("../admin/lead-details"));
const TermsAndConditions = React.lazy(() => import("../termsAndConditions"));
//const UserList = React.lazy(() => import("../admin/userlist"));
//const User = React.lazy(() => import("../admin/user"));
const SeriLogs = React.lazy(() => import("../admin/seriLog"));
const EmailLog = React.lazy(() => import("../admin/emailLog"));

const Enquiry = React.lazy(() => import("../admin/enquiry/enquiry"));
const EnquiryDetail = React.lazy(() => import("../admin/enquiry/enquiry-detail"));

const FollowUP = React.lazy(() => import("../admin/followup/followup"));
const FollowUPDetail = React.lazy(() => import("../admin/followup/followup-detail"));

const Category = React.lazy(() => import("../admin/category/category"));
const CategoryDetail = React.lazy(() => import("../admin/category/category-detail"));

const Course = React.lazy(() => import("../admin/course/course"));
const CourseDetail = React.lazy(() => import("../admin/course/course-detail"));

const WebUsers = React.lazy(() => import("../admin/webuser/webuser"));
const WebUsersDetail = React.lazy(() => import("../admin/webuser/webuser-detail"));

const Batch = React.lazy(() => import("../admin/batch/batch"));
const BatchDetail = React.lazy(() => import("../admin/batch/batch-detail"));

const Student = React.lazy(() => import("../admin/student/student"));
const StudentDetail = React.lazy(() => import("../admin/student/student-detail"));

const CourseFee = React.lazy(() => import("../admin/coursefee/coursefee"));

const StudentList = React.lazy(() => import("../admin/batch/student-list"));
const StudentAdd = React.lazy(() => import("../admin/batch/student-add"));
const StudentAttendanceList = React.lazy(() => import("../admin/batch/student-attendance-list"));
const AttendanceList = React.lazy(() => import("../admin/attendance/attendance"));

const PayCollection = React.lazy(() => import("../admin/payCollection/pay-collection"));

const AttendanceReport = React.lazy(() => import("../admin/attendance/attendance-report"));
const TotalStudentReport = React.lazy(() => import("../admin/dashboardReporting/total-student"));
const TotalEnquiryReport = React.lazy(() => import("../admin/dashboardReporting/total-enquiry"));
const TotalCurrentBatches = React.lazy(() => import("../admin/dashboardReporting/total-current-batches"));
const TotalCompletedBatches = React.lazy(() => import("../admin/dashboardReporting/total-completed-batches"));
const TotalPresent = React.lazy(() => import("../admin/dashboardReporting/total-present-student"));
const TotalAbsent = React.lazy(() => import("../admin/dashboardReporting/total-absent-student"));


const Router = function () {
    return (
        <Routes>
            <Route path="/job-status" element={<JobStatus />}></Route>
            <Route path="/" element={<LayoutDecider />}>
                <Route 
                    index 
                    path="/"
                    element={
                        <Suspense fallback={<Loading />}>
                            <Login />
                        </Suspense>
                    }
                />

                <Route
                    index
                    path="/dashboard/report/detail/TotalStudent"
                    element={
                        <Suspense fallback={<Loading />}>
                            <PrivateRoute role="ADMIN|FACULTY">
                                <TotalStudentReport/>
                            </PrivateRoute>
                        </Suspense>
                    }
                />

                 <Route
                    index
                    path="/dashboard/report/detail/TotalEnquiry"
                    element={
                        <Suspense fallback={<Loading />}>
                            <PrivateRoute role="ADMIN|FACULTY">
                                <TotalEnquiryReport/>
                            </PrivateRoute>
                        </Suspense>
                    }
                />

                <Route
                    index
                    path="/dashboard/report/detail/CurrentBatches"
                    element={
                        <Suspense fallback={<Loading />}>
                            <PrivateRoute role="ADMIN|FACULTY">
                                <TotalCurrentBatches/>
                            </PrivateRoute>
                        </Suspense>
                    }
                />

                <Route
                    index
                    path="/dashboard/report/detail/CompletedBatches"
                    element={
                        <Suspense fallback={<Loading />}>
                            <PrivateRoute role="ADMIN|FACULTY">
                                <TotalCompletedBatches/>
                            </PrivateRoute>
                        </Suspense>
                    }
                />

                
                <Route
                    index
                    path="/dashboard/report/detail/PresentStudent"
                    element={
                        <Suspense fallback={<Loading />}>
                            <PrivateRoute role="ADMIN|FACULTY">
                                <TotalPresent/>
                            </PrivateRoute>
                        </Suspense>
                    }
                />
                
                <Route
                    index
                    path="/dashboard/report/detail/AbsentStudent"
                    element={
                        <Suspense fallback={<Loading />}>
                            <PrivateRoute role="ADMIN|FACULTY">
                                <TotalAbsent/>
                            </PrivateRoute>
                        </Suspense>
                    }
                />



                <Route
                    index
                    path="/job-detail/:id"
                    element={
                        <Suspense fallback={<Loading />}>
                            <PrivateRoute role="CLIENT">
                                <PostedJobDetail />
                            </PrivateRoute>
                        </Suspense>
                    }
                />

                <Route
                    path="/my-posted-job"
                    element={
                        <Suspense fallback={<Loading />}>
                            <PrivateRoute role="CLIENT">
                                <PostedJobs />
                            </PrivateRoute>
                        </Suspense>
                    }
                />
                <Route
                    path="/login"
                    element={
                        <Suspense fallback={<Loading />}>
                            {/* <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_GOOGLERECAPCHA_KEY} scriptProps={{ defer: true, async: true }}> */}
                                <Login />
                            {/* </GoogleReCaptchaProvider> */}
                        </Suspense>
                    }
                />
                <Route
                    path="/forgot-password"
                    element={
                        <Suspense fallback={<Loading />}>
                                <ForgotPassword />
                        </Suspense>
                    }
                />
                <Route
                    path="/password-reset"
                    element={
                        <Suspense fallback={<Loading />}>
                            {/* <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_GOOGLERECAPCHA_KEY} scriptProps={{ defer: true, async: true }}> */}
                                <PasswordReset />
                            {/* </GoogleReCaptchaProvider> */}
                        </Suspense>
                    }
                />
                <Route
                    path="/register"
                    element={
                        <Suspense fallback={<Loading />}>
                            {/* <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_GOOGLERECAPCHA_KEY} scriptProps={{ defer: true, async: true }}> */}
                                <Register />
                            {/* </GoogleReCaptchaProvider> */}
                        </Suspense>
                    }
                />

                <Route
                    path="/profile"
                    element={
                        <Suspense fallback={<Loading />}>
                            <PrivateRoute>
                                <Profile />
                            </PrivateRoute>
                        </Suspense>
                    }
                />

                <Route
                    path="/change-password"
                    element={
                        <Suspense fallback={<Loading />}>
                            <PrivateRoute>
                                <ChangePassword />
                            </PrivateRoute>
                        </Suspense>
                    }
                />

                <Route
                    path="/terms-and-conditions"
                    element={
                        <Suspense fallback={<Loading />}>
                            <TermsAndConditions />
                        </Suspense>
                    }
                />
                <Route
                    index
                    path="/dashboard"
                    element={
                        <Suspense fallback={<Loading />}>
                            <PrivateRoute role="ADMIN|FACULTY">
                                <Dashboard />
                            </PrivateRoute>
                        </Suspense>
                    }
                />
                <Route
                    index
                    path="/admin/jobs"
                    element={
                        <Suspense fallback={<Loading />}>
                            <PrivateRoute role="ADMIN">
                                <Jobs />
                            </PrivateRoute>
                        </Suspense>
                    }
                />

                {/* Enquiry */}
                <Route
                    index
                    path="/enquiry"
                    element={
                        <Suspense fallback={<Loading />}>
                            <PrivateRoute role="ADMIN|FACULTY">
                                <Enquiry />
                            </PrivateRoute>
                        </Suspense>
                    }
                />
                <Route
                    index
                    path="/enquiry/detail/:type/:id?"
                    element={
                        <Suspense fallback={<Loading />}>
                            <PrivateRoute role="ADMIN|FACULTY">
                                <EnquiryDetail />
                            </PrivateRoute>
                        </Suspense>
                    }
                />
                {/* Enquiry */}
                    
                {/* Follow Up */}
                <Route
                    index
                    path="/:type/follow-up/:id"
                    element={
                        <Suspense fallback={<Loading />}>
                            <PrivateRoute role="ADMIN|FACULTY">
                                <FollowUP />
                            </PrivateRoute>
                        </Suspense>
                    }
                />
                <Route
                    index
                    path="/:type/follow-up/detail/:parentId/:operation/:id?"
                    element={
                        <Suspense fallback={<Loading />}>
                            <PrivateRoute role="ADMIN|FACULTY">
                                <FollowUPDetail />
                            </PrivateRoute>
                        </Suspense>
                    }
                />
                {/* Follow Up */}

                {/* Category */}
                <Route
                    index
                    path= "/course/:cattype/:parentCategoryId?"
                    element={
                        <Suspense fallback={<Loading />}>
                            <PrivateRoute role="ADMIN">
                                <Category />
                            </PrivateRoute>
                        </Suspense>
                    }
                />
                 <Route
                    index
                    path= "/course/:cattype/:operation/:categoryid?"
                    element={

                        <Suspense fallback={<Loading />}>
                            <PrivateRoute role="ADMIN">
                                <CategoryDetail />
                            </PrivateRoute>
                        </Suspense>
                    }
                />
                {/* Category */}

                {/* Course */}
                <Route
                    index
                    path= "/course"
                    element={
                        <Suspense fallback={<Loading />}>
                            <PrivateRoute role="ADMIN">
                                <Course />
                            </PrivateRoute>
                        </Suspense>
                    }
                />
                <Route
                    index
                    path="/course/detail/:type/:id?"
                    element={
                        <Suspense fallback={<Loading />}>
                            <PrivateRoute role="ADMIN">
                                <CourseDetail />
                            </PrivateRoute>
                        </Suspense>
                    }
                />
                {/* Course */}

                {/* Student Detail */}
                <Route
                    index
                    path= "/student/list"
                    element={
                        <Suspense fallback={<Loading />}>
                            <PrivateRoute role="ADMIN|FACULTY">
                                <Student />
                            </PrivateRoute>
                        </Suspense>
                    }
                />
                <Route
                    index
                    path="/student/detail/:type/:enquiryId?/:id?"
                    element={
                        <Suspense fallback={<Loading />}>
                            <PrivateRoute role="ADMIN|FACULTY">
                                <StudentDetail />
                            </PrivateRoute>
                        </Suspense>
                    }
                />
                {/* Student Detail */}

                {/* Course Fee */}
                <Route
                    index
                    path= "/student/course-fee/detail/:id"
                    element={
                        <Suspense fallback={<Loading />}>
                            <PrivateRoute role="ADMIN|FACULTY">
                                <CourseFee />
                            </PrivateRoute>
                        </Suspense>
                    }
                />

                {/* Course Fee */}


                {/* Web Users */}
                <Route
                    index
                    path= "/:userType/user/list"
                    element={
                        <Suspense fallback={<Loading />}>
                            <PrivateRoute role="ADMIN">
                                <WebUsers />
                            </PrivateRoute>
                        </Suspense>
                    }
                />
                <Route
                    index
                    path = "/:userType/detail/:type/:id?"
                    element={
                        <Suspense fallback={<Loading />}>
                            <PrivateRoute role="ADMIN">
                                <WebUsersDetail />
                            </PrivateRoute>
                        </Suspense>
                    }
                />
                {/* Web Users */}
                    
                {/* Batch */}
                <Route
                    index
                    path= "/batch/list"
                    element={
                        <Suspense fallback={<Loading />}>
                            <PrivateRoute role="ADMIN|FACULTY">
                                <Batch />
                            </PrivateRoute>
                        </Suspense>
                    }
                />
                <Route
                    index
                    path="/batch/detail/:type/:id?"
                    element={
                        <Suspense fallback={<Loading />}>
                            <PrivateRoute role="ADMIN|FACULTY">
                                <BatchDetail />
                            </PrivateRoute>
                        </Suspense>
                    }
                />

                 <Route
                    index
                    path="/batch/student/list/:id?"
                    element={
                        <Suspense fallback={<Loading />}>
                            <PrivateRoute role="ADMIN|FACULTY">
                                <StudentList />
                            </PrivateRoute>
                        </Suspense>
                    }
                />

                <Route
                    index
                    path="/batch/student/list/:id/add"
                    element={
                        <Suspense fallback={<Loading />}>
                            <PrivateRoute role="ADMIN|FACULTY">
                                <StudentAdd />
                            </PrivateRoute>
                        </Suspense>
                    }
                />

                <Route
                    index
                    path="/batch/:id/add-attendance"
                    element={
                        <Suspense fallback={<Loading />}>
                            <PrivateRoute role="FACULTY">
                                <StudentAttendanceList />
                            </PrivateRoute>
                        </Suspense>
                    }
                />

                {/* Batch */}

                {/* Attendance */}
                <Route
                    index
                    path="/attendance/history"
                    element={
                        <Suspense fallback={<Loading />}>
                            <PrivateRoute role="ADMIN|FACULTY">
                                <AttendanceList />
                            </PrivateRoute>
                        </Suspense>
                    }
                />
                {/* Attendance */}
                {/* Report */}
                <Route
                    index
                    path="/report/pay-collection"
                    element={
                        <Suspense fallback={<Loading />}>
                            <PrivateRoute role="ADMIN">
                                <PayCollection />
                            </PrivateRoute>
                        </Suspense>
                    }
                />

                <Route
                    index
                    path="/report/attendance"
                    element={
                        <Suspense fallback={<Loading />}>
                            <PrivateRoute role="ADMIN">
                                <AttendanceReport />
                            </PrivateRoute>
                        </Suspense>
                    }
                />

                {/* Report */}

                <Route
                    index
                    path="/admin/lead-generation"
                    element={
                        <Suspense fallback={<Loading />}>
                            <PrivateRoute role="ADMIN">
                                <LeadGeneration />
                            </PrivateRoute>
                        </Suspense>
                    }
                />
                <Route
                    index
                    path="/admin/lead-details/:organisationid"
                    element={
                        <Suspense fallback={<Loading />}>
                            <PrivateRoute role="ADMIN">
                                <LeadDetails />
                            </PrivateRoute>
                        </Suspense>
                    }
                />
                {/* <Route
                    index
                    path="/admin/user/:clienttype"
                    element={
                        <Suspense fallback={<Loading />}>
                            <PrivateRoute role="ADMIN">
                                <UserList />
                            </PrivateRoute>
                        </Suspense>
                    }
                /> */}
                {/* <Route
                    index
                    path="/admin/user/:clienttype/:type/:id?"
                    element={
                        <Suspense fallback={<Loading />}>
                            <PrivateRoute role="ADMIN">
                                <User />
                            </PrivateRoute>
                        </Suspense>
                    }
                /> */}
                <Route
                    index
                    path="/admin/serilog/list"
                    element={
                        <Suspense fallback={<Loading />}>
                            <PrivateRoute role="ADMIN">
                                <SeriLogs />
                            </PrivateRoute>
                        </Suspense>
                    }
                />
                <Route
                    index
                    path="/admin/emaillog/list"
                    element={
                        <Suspense fallback={<Loading />}>
                            <PrivateRoute role="ADMIN">
                                <EmailLog />
                            </PrivateRoute>
                        </Suspense>
                    }
                />
                <Route path="*" element={<NoMatch />} />
            </Route>
            <Route path="/unauthorized" element={<Unauthorized />} />
            <Route path="*" element={<NoMatch />} />
        </Routes>
    );
};

export default Router;
